/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free BMI calculator. Enter your height and weight in metric or imperial units to get your Body Mass Index and category instantly.`)
};

const es_bmi_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de IMC gratuita. Introduce tu altura y peso en unidades métricas o imperiales para obtener tu Índice de Masa Corporal y categoría instantáneamente.`)
};

const de_bmi_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser BMI-Rechner. Geben Sie Ihre Größe und Gewicht in metrischen oder kaiserlichen Einheiten ein, um Ihren Body-Mass-Index und die Kategorie sofort zu erhalten.`)
};

const nl_bmi_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis BMI-rekenmachine. Voer uw lengte en gewicht in metrische of imperiale eenheden in om uw Body Mass Index en categorie onmiddellijk te krijgen.`)
};

const fr_bmi_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur IMC gratuit. Entrez votre taille et votre poids en unités métriques ou impériales pour obtenir votre indice de masse corporelle et sa catégorie instantanément.`)
};

const it_bmi_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore BMI gratuito. Inserisci la tua altezza e il tuo peso in unità metriche o imperiali per ottenere il tuo Indice di Massa Corporea e categoria istantaneamente.`)
};

const pt_br2_bmi_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora BMI gratuita. Digite sua altura e peso em unidades métricas ou imperiais para obter seu Índice de Massa Corporal e categoria instantaneamente.`)
};

const pt_bmi_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de IMC gratuita. Digite a sua altura e peso em unidades métricas ou imperiais para obter o seu Índice de Massa Corporal e categoria instantaneamente.`)
};

const ja_bmi_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のBMI計算機。メートル法またはインペリアル単位で身長と体重を入力して、体格指数とカテゴリをすぐに取得できます。`)
};

const zh_bmi_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 BMI 计算器。输入公制或英制单位的身高和体重，即可立即获得您的身体质量指数及所属类别。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_hub_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_hub_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_hub_meta_description", locale)
	if (locale === "en") return en_bmi_hub_meta_description(inputs)
	if (locale === "es") return es_bmi_hub_meta_description(inputs)
	if (locale === "de") return de_bmi_hub_meta_description(inputs)
	if (locale === "nl") return nl_bmi_hub_meta_description(inputs)
	if (locale === "fr") return fr_bmi_hub_meta_description(inputs)
	if (locale === "it") return it_bmi_hub_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_hub_meta_description(inputs)
	if (locale === "pt") return pt_bmi_hub_meta_description(inputs)
	if (locale === "ja") return ja_bmi_hub_meta_description(inputs)
	return zh_bmi_hub_meta_description(inputs)
};